import { EditorPlatform } from '@wix/ambassador-cc-helpcenter-v1-related-document/types';

import { EDITOR_TYPE } from '../common/messageCreators';
import { renderModel } from './renderModel';

export const editorTypeToFilterPlatform: Partial<Record<EDITOR_TYPE, EditorPlatform>> = {
  [EDITOR_TYPE.EDITOR]: EditorPlatform.EDITOR,
  [EDITOR_TYPE.EDITOR3]: EditorPlatform.EDITOR_3,
  [EDITOR_TYPE.STUDIO]: EditorPlatform.STUDIO,
  [EDITOR_TYPE.PICASSO]: EditorPlatform.PICASSO,
  [EDITOR_TYPE.ODEDITOR]: EditorPlatform.EDITOR_3,
  [EDITOR_TYPE.STUDIO_TWO]: EditorPlatform.STUDIO_2,
};

export function getEditorTypeFilter(): EditorPlatform | undefined {
  if (renderModel.isEditor3()) {
    return EditorPlatform.EDITOR_3;
  }

  if (renderModel.isStudio2Editor()) {
    return EditorPlatform.STUDIO_2;
  }

  if (renderModel.isStudioEditor()) {
    return EditorPlatform.STUDIO;
  }

  if (renderModel.isEditor()) {
    return EditorPlatform.EDITOR;
  }

  return undefined;
}
